// extracted by mini-css-extract-plugin
export default {"container":"UserRoleManagement_container__iCOta","table":"UserRoleManagement_table__BTITg","button":"UserRoleManagement_button__kkn2y"};